<template>
  <section class="banner bg-gradient-green-reverse section-padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <h2>¡Inicia sesión!</h2>
            <router-link to="" @click.native="goToAppLogin" class="btn btn-dark p-4">Inicia sesión</router-link>
            <router-link to="" @click.native="goToApplicantRegister" class="btn btn-dark p-4 ml--2">Quiero ser inversionista</router-link>
            <router-link to="" @click.native="goToSupplierRegister" class="btn btn-dark p-4 ml--2">Quiero ser proveedor</router-link>
          </div><!-- end meet-heading -->
        </div><!-- end col-md-12 -->
      </div><!-- end row -->
    </div><!-- container -->    
  </section>
</template>

<script>
export default {
  name: "RC17LightBanner"
}
</script>

<style scoped>
.banner {
  min-height: 0 !important;
}
</style>